import * as React from 'react';

import { Avatar, Divider, Typography } from 'antd';

import type { ChangeHistoryContentItem } from 'v2/interfaces/productChangeHistory';

import { Icon } from '@eduzz/ui-antd-theme';

type ChangeHistoryItemProps = {
  content: ChangeHistoryContentItem;
  onOpenDetails: (data: ChangeHistoryContentItem) => void;
};

export const ChangeHistoryItem = ({ content, onOpenDetails }: ChangeHistoryItemProps) => {
  const accountDescription = () => {
    if (content.isChangedBySupport) return 'Via Suporte Eduzz';
    if (content.isChangedByProducer) return 'Titular da conta';
    return 'Via controle de acesso';
  };

  const formatDate = (dateRaw: string) =>
    new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'medium' }).format(new Date(dateRaw));

  return (
    <>
      <div className='flex cursor-pointer items-center justify-between' onClick={() => onOpenDetails(content)}>
        <div className='flex'>
          <Avatar src={content.customerPhoto} alt={content.customerNameWhoModified} />
          <div className='ml-3'>
            <div>{formatDate(content.historyCreatedAt)}</div>
            <div>
              {content.customerNameWhoModified}{' '}
              <Typography.Text className='text-content-subtitle'>
                {accountDescription()} - {content.customerEmail}
              </Typography.Text>
            </div>
          </div>
        </div>
        <div>
          <Icon.ChevronRight size={16} />
        </div>
      </div>
      <Divider className='my-3' />
    </>
  );
};
